
import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import WizardContainer from "../components/portfolioCreationWizard/components/WizardContainer";

const PortfolioCreationWizardPrototype = () => {

    return (

        <MainWrapper>
            <WizardContainer wizardTitle="PROTOTYPE TS Portfolio Creation Wizard MVP"
            onExitWithoutSaving={() => { console.log('Exit without saving') }}
            onFinish={async (progress) => {
                console.log('Finish Wizard:', { progress })
                await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate async operation
                alert('Finish action');
            } } />
        </MainWrapper>
    );
};

const MainWrapper = styled(Box)`
    position: fixed;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin-bottom: 100px;
    padding-bottom: 10px;
`;



export default PortfolioCreationWizardPrototype;
